import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./como_transaction_id_source.js";
//#region src/como_transaction_id_source_helper.ts
var como_transaction_id_source_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(idSource) {
	switch (idSource) {
		case "client-id": return "Client ID";
		case "order-id": return "Order ID";
		case "sequence-id": return "Sequence ID";
	}
}
//#endregion
export { como_transaction_id_source_helper_exports, name };

//# sourceMappingURL=como_transaction_id_source_helper.js.map